import { render } from "./dap-info.vue?vue&type=template&id=4a36ec2a"
import script from "./dap-info.js?vue&type=script&lang=js"
export * from "./dap-info.js?vue&type=script&lang=js"

import "./dap-info.vue?vue&type=style&index=0&id=4a36ec2a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__